import { AlertTriangle, Lock } from 'lucide-react';
import type { SessionStatus } from '../lib/session';

interface SessionBannerProps {
  status: SessionStatus;
  secondsRemaining: number | null;
}

export function SessionBanner({ status, secondsRemaining }: SessionBannerProps) {
  if (status === 'active' || status === 'no-expiry') return null;

  if (status === 'expiring') {
    const mins = secondsRemaining != null ? Math.max(1, Math.ceil(secondsRemaining / 60)) : null;
    return (
      <div
        role="status"
        aria-live="polite"
        className="sticky top-0 z-50 flex items-center gap-2 bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-2 text-sm"
      >
        <AlertTriangle size={18} className="flex-shrink-0" />
        <span>
          Your session expires{mins != null ? ` in ~${mins} min` : ' soon'}. Save your
          work now to avoid losing it.
        </span>
      </div>
    );
  }

  // status === 'expired'
  return (
    <div
      role="alert"
      className="sticky top-0 z-50 flex items-center gap-3 bg-red-600 text-white px-4 py-2 text-sm"
    >
      <Lock size={18} className="flex-shrink-0" />
      <span className="flex-1">
        Your session has expired. Reload the page to continue; unsaved changes will be lost.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        name="reload"
        className="px-3 py-1 bg-white text-red-700 rounded font-medium hover:bg-red-50"
      >
        Reload
      </button>
    </div>
  );
}
